import React from 'react';

// NOTE: Translated from mobile app HeightLimiter component by sonnet-4.5.
const HeightLimiter = (props: {
  // Defaults to 400
  maxHeight?: number;
  // Buffer addresses the case where the content is trivially larger than the
  // maxHeight. We don't want the user to have to press just to expand a
  // section by half a pixel.
  // Defaults to 50
  buffer?: number;
  disablePressToExpand?: boolean;
  children: React.ReactNode;
}) => {
  const maxHeight = props.maxHeight ?? 400;
  const buffer = props.buffer ?? 50;

  const [isExpanded, setIsExpanded] = React.useState(false);
  // null = not measured yet
  const [contentHeight, setContentHeight] = React.useState<number | null>(null);
  const measureRef = React.useRef<HTMLDivElement>(null);

  const exceedsHeight = contentHeight !== null && contentHeight > maxHeight;

  // Measure content on mount
  React.useEffect(() => {
    if (measureRef.current && contentHeight === null) {
      const height = measureRef.current.offsetHeight;
      setContentHeight(height);
      if (height > maxHeight && height < maxHeight + buffer) {
        setIsExpanded(true);
      }
    }
  }, [contentHeight]);

  return (
    <div className="tw-relative">
      <div
        className="tw-relative tw-overflow-hidden"
        style={
          !isExpanded
            ? {
                WebkitMaskImage: exceedsHeight
                  ? 'linear-gradient(to bottom, black calc(100% - 80px), transparent calc(100% - 1.25rem))'
                  : undefined,
                maskImage: exceedsHeight
                  ? 'linear-gradient(to bottom, black calc(100% - 80px), transparent calc(100% - 1.25rem))'
                  : undefined,
                maxHeight: `${maxHeight}px`,
              }
            : undefined
        }
      >
        {!isExpanded && exceedsHeight && !props.disablePressToExpand ? (
          <div onClick={() => setIsExpanded(true)} className="tw-cursor-pointer">
            {props.children}
          </div>
        ) : (
          <>{props.children}</>
        )}
      </div>

      {!isExpanded && exceedsHeight && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="tw-absolute tw-bottom-0 tw-flex tw-justify-center tw-w-full tw-pb-1 tw-text-blue tw-text-[0.95rem] tw-font-semibold tw-cursor-pointer"
        >
          Show More
        </button>
      )}

      {/* Hidden measurement copy */}
      {contentHeight === null && (
        <div
          ref={measureRef}
          style={{
            opacity: 0,
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: -1,
          }}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};

export default HeightLimiter;
